
export const ANNOUNCEMENT_API = {
    // on load
    onLoad: 'hrms|announcement|room|event',
    alert: 'hrms|announcement|alert',
    // events
    events: 'hrms|announcement|user|events',

    // Birthday
    createWish: 'hrms|announcement|wishes|create',
    updateWish: 'hrms|announcement|wishes|update',
    checkWish: 'hrms|announcement|wishes|fetch',

    // list
    myPostList: 'hrms|announcement|myFeedList',
    postList: 'hrms|announcement|feedList',
    postRecentBy: 'hrms|announcement|postRecentlyBy',

    // Post
    postCreate: 'hrms|announcement|post|create',
    postUpdate: 'hrms|announcement|post|update',
    postTagList:'hrms|announcement|postTag|list',
    postTagCreate:'hrms|announcement|postTag|create',
    readConfirm:'hrms|announcement|post|readConfirm',
    publishPost:'hrms|announcement|post|publish',
    tagDelete: 'hrms|announcement|postTag|delete',

    // Poll
    pollCreate: 'hrms|announcement|poll|create',
    pollUpdate: 'hrms|announcement|poll|update',
    addVote: 'hrms|announcement|poll|castVote',

    // post menu
    bookMarkPost:'hrms|announcement|post|bookmark',
    deletePost:'hrms|announcement|post|delete',
    sharePostList: 'hrms|announcement|dropList|share',
    shareFeed: 'hrms|announcement|shareFeed',
    
    // fetch post
    fetchPost: 'hrms|announcement|feed|fetch',

    updateCount: 'hrms|announcement|count',
}